import { render, staticRenderFns } from "./Lottie.pug?vue&type=template&id=1776cd55&scoped=true&lang=pug&"
import script from "./Lottie.vue?vue&type=script&lang=js&"
export * from "./Lottie.vue?vue&type=script&lang=js&"
import style0 from "./Lottie.scss?vue&type=style&index=0&id=1776cd55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776cd55",
  null
  
)

export default component.exports